<div [innerHTML]="record[this.column.field]"></div>
